import SecretariatReviewStatus from "./SecretariatReviewStatus";

export default SecretariatReviewStatus;
